module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABASURBVChTY2RgaPjPgAMwQWmsAC75/389lIUAKDrRFWAYi6wAq50wBVglGRkbwTSGJEwCBFAkkSVAgNxAYGAAAKTfDpAJdDeCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/STARTARA.png
// module id = 102
// module chunks = 0